// src/HeartFill.tsx
import * as React from "react";
var HeartFill = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M10.47 14.12c-.27.24-.68.24-.94 0l-.54-.5C5.38 10.35 3 8.19 3 5.55 3 3.39 4.69 1.7 6.85 1.7c1.22 0 2.39.57 3.15 1.46.76-.89 1.93-1.46 3.15-1.46C15.31 1.7 17 3.39 17 5.55c0 2.64-2.38 4.8-5.99 8.07l-.54.5z" })
);
HeartFill.displayName = "HeartFill";
export {
  HeartFill
};
